import { render, staticRenderFns } from "./PuntodeVenta.vue?vue&type=template&id=6d77ee12&scoped=true"
import script from "./PuntodeVenta.vue?vue&type=script&lang=js"
export * from "./PuntodeVenta.vue?vue&type=script&lang=js"
import style0 from "./PuntodeVenta.vue?vue&type=style&index=0&id=6d77ee12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d77ee12",
  null
  
)

export default component.exports